export default __webpack_public_path__ + "static/media/autoMotive.eba7d6e6.svg";